import { apiUrl } from './config'
import request from '@/utils/request'

const STAR_VERSION_HEADERS = { starVersion: '1.1' } as const

function starHeaders(headers?: Record<string, any>) {
  return { ...(headers || {}), ...STAR_VERSION_HEADERS }
}

export const mockYieldTrendData = () => {
  return new Promise((resolve) => {
    setTimeout(() => {
      resolve({
        strategy: [
          { date: '2025-01-01', value: 100 },
          { date: '2025-02-01', value: 400 },
          { date: '2025-03-01', value: 200 },
          { date: '2025-04-01', value: 100 },
          { date: '2025-05-01', value: 200 },
          { date: '2025-06-01', value: 200 },
          { date: '2025-07-01', value: 400 },
          { date: '2025-08-01', value: 500 },
          { date: '2025-09-01', value: 800 },
          { date: '2025-10-01', value: 500 },
          { date: '2025-11-01', value: 400 },
          { date: '2025-12-01', value: 300 },
        ],
        benchmark: [
          { date: '2025-01-01', value: 180 },
          { date: '2025-02-01', value: 220 },
          { date: '2025-03-01', value: 260 },
          { date: '2025-04-01', value: 280 },
          { date: '2025-05-01', value: 260 },
          { date: '2025-06-01', value: 200 },
          { date: '2025-07-01', value: 240 },
          { date: '2025-08-01', value: 320 },
          { date: '2025-09-01', value: 480 },
          { date: '2025-10-01', value: 640 },
          { date: '2025-11-01', value: 660 },
          { date: '2025-12-01', value: 580 },
        ]
      });
    }, 500);
  });
};

export const mockTransactionDetails = (page = 1, pageSize = 10) => {
  return new Promise((resolve) => {
    setTimeout(() => {
      const data = Array.from({ length: pageSize }).map((_, i) => ({
        id: (page - 1) * pageSize + i + 1,
        name: '贵州茅台',
        code: '600519',
        action: i % 2 === 0 ? '买入' : '卖出', // 买红卖绿
        costPrice: 1351.06,
        quantity: 3200,
        amount: 12300,
        profit: i % 2 === 0 ? 1265.36 : -2365.36,
        datetime: '2024-02-25 13:25:23',
      }));
      resolve({
        data,
        total: 38
      });
    }, 500);
  });
};

export const mockCurrentHoldings = () => {
  return new Promise((resolve) => {
    setTimeout(() => {
      const data = Array.from({ length: 10 }).map((_, i) => ({
        id: i + 1,
        name: '贵州茅台',
        code: '600519',
        profit: i % 2 === 0 ? 2000.45 : -2000.23, // 红涨绿跌
        currentPrice: 17.38,
        costPrice: 1351.06,
        position: '4.50%',
        industry: '白酒',
      }));
      resolve(data);
    }, 500);
  });
};

export const mockStrategyDetails = () => {
  return new Promise((resolve) => {
    setTimeout(() => {
      resolve({
        strategyYield: 153.09,
        annualizedYield: 62.87,
        winRate: 73.09,
        profitLossRatio: 20.9,
        maxDrawdown: 12.14,
      });
    }, 500);
  });
};

export const strategyAction = (data?: any) => {
  return request({
    url: apiUrl + '/rjhy-factor-selector/api/1/quantstar/strategy/action' ,
    method: 'post',
    data: data?.data,
    headers: starHeaders({
      'Content-Type': 'application/json',
      ...data?.headers
    }),
    sign: true,
    newSign: true
  });
};

export const fetchStrategyReturnDetail = (data?: any) => {
  return request({
    url: apiUrl + '/rjhy-factor-selector/api/1/quantstar/strategy/returndetail',
    method: 'get',
    params: data?.data,
    headers: starHeaders({
      'Content-Type': 'application/x-www-form-urlencoded',
      ...data?.headers
    }),
    sign: true,
    newSign: true
  });
};

export const fetchStrategyDetail = (data?: any) => {
  return request({
    url: apiUrl + '/rjhy-factor-selector/api/1/quantstar/strategy/detail',
    method: 'get',
    params: data?.data,
    headers: starHeaders({
      'Content-Type': 'application/x-www-form-urlencoded',
      ...data?.headers
    }),
    sign: true,
    newSign: true
  });
};

export const fetchTradeDetails = (data?: any) => {
  return request({
    url: apiUrl + '/rjhy-factor-selector/api/1/quantstar/oplog/com',
    method: 'get',
    params: data?.data,
    headers: starHeaders({
      'Content-Type': 'application/x-www-form-urlencoded',
      ...data?.headers
    }),
    sign: true,
    newSign: true
  });
};
